import React, { memo, useMemo, useRef } from 'react';

import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { isEmpty } from 'lodash';
import { GridComponent } from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import { buildConsolidatedGraphOption } from '../Telemetry/helper';
import { AGGREGATIONS_FOR_GRAPH, CONSOLIDATED_ECHARTS_INITIAL_INSIDE_TOP_GAP, GAP_BETWEEN_CONSOLIDATED_ECHARTS } from '../Telemetry/const';
import ExportComponent from '../Telemetry/components/Graph/export';
import './_styles.scss';
import { WHITE_COLOR } from '../../../../const';

echarts.use([GridComponent, SVGRenderer]);

const ConsolidatedChargerEchart = (options) => {
  const echartRef = useRef(null);
  const echartSliderRef = useRef(null);

  const { selectedMetrics, chargerMetrics, offset, isRealTime, isDemo } = options;

  const withAggregation = AGGREGATIONS_FOR_GRAPH.some((agg) => Object.prototype.hasOwnProperty.call(chargerMetrics, agg));
  const option = buildConsolidatedGraphOption({ withAggregation, isHistory: !isRealTime, ...options });
  const CANVAS_HEIGHT = selectedMetrics.length * GAP_BETWEEN_CONSOLIDATED_ECHARTS + CONSOLIDATED_ECHARTS_INITIAL_INSIDE_TOP_GAP;

  const isNotSelectedMetric = isEmpty(selectedMetrics);

  const onlyDataZoomOption = {
    grid: {
      height: 40,
      left: 40,
      right: 40,
    },
    dataZoom: [
      {
        type: 'inside',
      },
      {
        type: 'slider',
        top: 0,
      },
    ],
    xAxis: {
      show: false,
    },
    yAxis: {
      show: false,
    },
  };

  const onEvents = useMemo(
    () => ({
      dataZoom: (params) => {
        if (params.batch) {
          const { start, end } = params.batch[0];

          echartSliderRef.current?.getEchartsInstance().dispatchAction({
            type: 'dataZoom',
            start,
            end,
            startValue: start,
            endValue: end,
          });
        }
      },
    }),
    [],
  );

  const onSliderEvents = useMemo(
    () => ({
      dataZoom: ({ start, end }) => {
        echartRef.current?.getEchartsInstance().dispatchAction({
          type: 'dataZoom',
          start,
          end,
          startValue: start,
          endValue: end,
        });
      },
    }),
    [],
  );

  if (isNotSelectedMetric) return null;

  return (
    <>
      <div className="consolidated-charger__button-container">
        <ExportComponent
          dates={Object.keys(chargerMetrics)}
          metric={selectedMetrics}
          chargerMetrics={chargerMetrics}
          offset={offset}
          isRealTime={isRealTime}
          isDemo={isDemo}
        />
      </div>
      <ReactECharts
        ref={echartRef}
        option={option}
        echarts={echarts}
        notMerge
        lazyUpdate
        onEvents={onEvents}
        style={{ height: CANVAS_HEIGHT, background: WHITE_COLOR, boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)' }}
      />
      <div className="consolidated-charger__slider">
        <ReactECharts ref={echartSliderRef} option={onlyDataZoomOption} onEvents={onSliderEvents} />
      </div>
    </>
  );
};

export default memo(ConsolidatedChargerEchart);
